export const CurtainsRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="59"
    height="58"
    viewBox="0 0 59 58"
  >
    <defs>
      <filter
        id="dr15cnt6wa"
        width="150%"
        height="151.1%"
        x="-25%"
        y="-14.4%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="5" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="3" />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0.407843137 0 0 0 0 0.607843137 0 0 0 0 0.878431373 0 0 0 0.24 0"
        />
      </filter>
      <rect id="hexsemka3b" width="46" height="45" x="2.408" y="2" rx="16" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g transform="translate(-278 -550) translate(282 550)">
            <use fill="#000" filter="url(#dr15cnt6wa)" xlinkHref="#hexsemka3b" />
            <use fill="#FFF" xlinkHref="#hexsemka3b" />
          </g>
          <g fill="#2396FD" fillRule="nonzero">
            <g>
              <path
                d="M12.228 7.5L20.092 -5 12.982 -5 5.092 7.5 5.092 7.472 12.982 20 20.092 20 12.228 7.472"
                transform="translate(-278 -550) translate(282 550) matrix(0 1 1 0 18.908 13) translate(.5) matrix(0 -1 -1 0 20.092 20.092)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
